export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'users',
      displayName: 'Usuarios',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'firmas',
      displayName: 'Firmas electrónicas',
      meta: {
        icon: 'signature',
      },
    },
    /*{
      name: 'finanzas',
      displayName: 'Finanzas',
      meta: {
        icon: 'account_balance_wallet',
      },
    },
    
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'home',
      },
    },

    {
      name: 'administracion',
      displayName: 'menu.administration',
      meta: {
        icon: 'admin_panel_settings',
      },
    },
    {
      name: 'reports',
      displayName: 'menu.reports',
      meta: {
        icon: 'insert_chart',
      },
    },*/
  ] as INavigationRoute[],
}
